export default "__VITE_PUBLIC_ASSET__ed71fcd1__"